import { ModeloVariavel } from './modelo-variavel';

export interface VarianteVariavel<T> {
	enum: T;
	getLabel: (variante: string) => string;
	getTimeIndexSteps: (variante: string) => number;
}

enum ModeloVarianteVariavelPrecipitacao {
	PRECIPITACAO_ACUMULADA_24H = 'PRECIPITACAO_ACUMULADA_24H',
	PRECIPITACAO_ACUMULADA_3H = 'PRECIPITACAO_ACUMULADA_3H',
	PRECIPITACAO_1H = 'PRECIPITACAO',
}

export const VarianteVariavelPrecipitacao: VarianteVariavel<
	typeof ModeloVarianteVariavelPrecipitacao
> = {
	enum: ModeloVarianteVariavelPrecipitacao,
	getLabel: (variante: ModeloVarianteVariavelPrecipitacao | string): string => {
		switch (variante) {
			case ModeloVarianteVariavelPrecipitacao.PRECIPITACAO_1H:
				return 'Precipitação horária (mm)';
			case ModeloVarianteVariavelPrecipitacao.PRECIPITACAO_ACUMULADA_3H:
				return 'Precipitação acumulada em 3h (mm)';
			case ModeloVarianteVariavelPrecipitacao.PRECIPITACAO_ACUMULADA_24H:
				return 'Precipitação acumulada em 24h (mm)';
			default:
				return '';
		}
	},
	getTimeIndexSteps: (
		variante: ModeloVarianteVariavelPrecipitacao | string
	): number => {
		switch (variante) {
			case ModeloVarianteVariavelPrecipitacao.PRECIPITACAO_ACUMULADA_3H:
				return 3;
			case ModeloVarianteVariavelPrecipitacao.PRECIPITACAO_ACUMULADA_24H:
				return 24;
			default:
				return 1;
		}
	},
};

enum ModeloVarianteVariavelTemperatura {
	TEMPERATURA_2_METROS = 'TEMPERATURA_2_METROS',
	TEMPERATURA_2_METROS_MAXIMA = 'TEMPERATURA_2_METROS_MAXIMA',
	TEMPERATURA_2_METROS_MINIMA = 'TEMPERATURA_2_METROS_MINIMA',
}

export const VarianteVariavelTemperatura: VarianteVariavel<
	typeof ModeloVarianteVariavelTemperatura
> = {
	enum: ModeloVarianteVariavelTemperatura,
	getLabel: (variante: ModeloVarianteVariavelTemperatura | string): string => {
		switch (variante) {
			case ModeloVarianteVariavelTemperatura.TEMPERATURA_2_METROS:
				return 'Temperatura a 2m (ºC)';
			case ModeloVarianteVariavelTemperatura.TEMPERATURA_2_METROS_MAXIMA:
				return 'Temperatura a 2m máxima (ºC)';
			case ModeloVarianteVariavelTemperatura.TEMPERATURA_2_METROS_MINIMA:
				return 'Temperatura a 2m mínima (ºC)';
			default:
				return '';
		}
	},
	getTimeIndexSteps: (
		variante: ModeloVarianteVariavelTemperatura | string
	): number => {
		switch (variante) {
			case ModeloVarianteVariavelTemperatura.TEMPERATURA_2_METROS_MAXIMA:
			case ModeloVarianteVariavelTemperatura.TEMPERATURA_2_METROS_MINIMA:
				return 24;
			default:
				return 1;
		}
	},
};

enum ModeloVarianteVariavelUmidade {
	UMIDADE_AR_2_METROS = 'UMIDADE_AR_2_METROS',
	UMIDADE_AR_850_HPA = 'UMIDADE_AR_850_HPA',
}

export const VarianteVariavelUmidade: VarianteVariavel<
	typeof ModeloVarianteVariavelUmidade
> = {
	enum: ModeloVarianteVariavelUmidade,
	getLabel: (variante: ModeloVarianteVariavelUmidade | string): string => {
		switch (variante) {
			case ModeloVarianteVariavelUmidade.UMIDADE_AR_2_METROS:
				return 'Umidade relativa a 2m (%)';
			case ModeloVarianteVariavelUmidade.UMIDADE_AR_850_HPA:
				return 'Umidade relativa a 850 hPa (%)';
			default:
				return '';
		}
	},
	getTimeIndexSteps: (_: ModeloVarianteVariavelUmidade | string): number => 1,
};

enum ModeloVarianteVariavelVento {
	VENTO_10_METROS = 'VENTO_10_METROS',
	VENTO_10_METROS_MAXIMO = 'VENTO_10_METROS_MAXIMO',
	VENTO_925_HPA = 'VENTO_925_HPA',
	VENTO_850_HPA = 'VENTO_850_HPA',
	VENTO_700_HPA = 'VENTO_700_HPA',
	VENTO_500_HPA = 'VENTO_500_HPA',
	VENTO_250_HPA = 'VENTO_250_HPA',
}

export const VarianteVariavelVento: VarianteVariavel<
	typeof ModeloVarianteVariavelVento
> = {
	enum: ModeloVarianteVariavelVento,
	getLabel: (variante: ModeloVarianteVariavelVento | string): string => {
		switch (variante) {
			case ModeloVarianteVariavelVento.VENTO_10_METROS:
				return 'Vento a 10m (m/s)';
			case ModeloVarianteVariavelVento.VENTO_10_METROS_MAXIMO:
				return 'Vento máximo a 10m (m/s)';
			case ModeloVarianteVariavelVento.VENTO_925_HPA:
				return 'Vento a 925 hPa (m/s)';
			case ModeloVarianteVariavelVento.VENTO_850_HPA:
				return 'Vento a 850 hPa (m/s)';
			case ModeloVarianteVariavelVento.VENTO_700_HPA:
				return 'Vento a 700 hPa (m/s)';
			case ModeloVarianteVariavelVento.VENTO_500_HPA:
				return 'Vento a 500 hPa (m/s)';
			case ModeloVarianteVariavelVento.VENTO_250_HPA:
				return 'Vento a 250 hPa (m/s)';
			default:
				return '';
		}
	},
	getTimeIndexSteps: (
		variante: ModeloVarianteVariavelVento | string
	): number => {
		switch (variante) {
			case ModeloVarianteVariavelVento.VENTO_10_METROS_MAXIMO:
				return 24;
			default:
				return 1;
		}
	},
};

enum ModeloVarianteVariavelDivergenciaVento {
	DIVERGENCIA_VENTO_250_HPA = 'DIVERGENCIA_VENTO_250_HPA',
	DIVERGENCIA_VENTO_500_HPA = 'DIVERGENCIA_VENTO_500_HPA',
	DIVERGENCIA_VENTO_850_HPA = 'DIVERGENCIA_VENTO_850_HPA',
}

export const VarianteVariavelDivergenciaVento: VarianteVariavel<
	typeof ModeloVarianteVariavelDivergenciaVento
> = {
	enum: ModeloVarianteVariavelDivergenciaVento,
	getLabel: (
		variante: ModeloVarianteVariavelDivergenciaVento | string
	): string => {
		switch (variante) {
			case ModeloVarianteVariavelDivergenciaVento.DIVERGENCIA_VENTO_250_HPA:
				return 'Divergência do vento a 250 hPa (10^-5 s^-1)';
			case ModeloVarianteVariavelDivergenciaVento.DIVERGENCIA_VENTO_500_HPA:
				return 'Divergência do vento a 500 hPa (10^-5 s^-1)';
			case ModeloVarianteVariavelDivergenciaVento.DIVERGENCIA_VENTO_850_HPA:
				return 'Divergência do vento a 850 hPa (10^-5 s^-1)';
			default:
				return '';
		}
	},
	getTimeIndexSteps: (
		_: ModeloVarianteVariavelDivergenciaVento | string
	): number => 1,
};

enum ModeloVarianteVariavelVorticidadeRelativa {
	VORTICIDADE_RELATIVA_250_HPA = 'VORTICIDADE_RELATIVA_250_HPA',
	VORTICIDADE_RELATIVA_500_HPA = 'VORTICIDADE_RELATIVA_500_HPA',
	VORTICIDADE_RELATIVA_850_HPA = 'VORTICIDADE_RELATIVA_850_HPA',
}

export const VarianteVariavelVorticidadeRelativa: VarianteVariavel<
	typeof ModeloVarianteVariavelVorticidadeRelativa
> = {
	enum: ModeloVarianteVariavelVorticidadeRelativa,
	getLabel: (
		variante: ModeloVarianteVariavelVorticidadeRelativa | string
	): string => {
		switch (variante) {
			case ModeloVarianteVariavelVorticidadeRelativa.VORTICIDADE_RELATIVA_250_HPA:
				return 'Vorticidade relativa a 250 hPa (10-5 s-1)';
			case ModeloVarianteVariavelVorticidadeRelativa.VORTICIDADE_RELATIVA_500_HPA:
				return 'Vorticidade relativa a 500 hPa (10^-5 s^-1)';
			case ModeloVarianteVariavelVorticidadeRelativa.VORTICIDADE_RELATIVA_850_HPA:
				return 'Vorticidade relativa a 850 hPa (10^-5 s^-1)';
			default:
				return '';
		}
	},
	getTimeIndexSteps: (
		_: ModeloVarianteVariavelVorticidadeRelativa | string
	): number => 1,
};

enum ModeloVarianteVariavelNebulosidade {
	NEBULOSIDADE_BAIXA = 'NEBULOSIDADE_BAIXA',
	NEBULOSIDADE_MEDIA = 'NEBULOSIDADE_MEDIA',
	NEBULOSIDADE_ALTA = 'NEBULOSIDADE_ALTA',
	NEBULOSIDADE_TOTAL = 'NEBULOSIDADE_TOTAL',
}

export const VarianteVariavelNebulosidade: VarianteVariavel<
	typeof ModeloVarianteVariavelNebulosidade
> = {
	enum: ModeloVarianteVariavelNebulosidade,
	getLabel: (variante: ModeloVarianteVariavelNebulosidade | string): string => {
		switch (variante) {
			case ModeloVarianteVariavelNebulosidade.NEBULOSIDADE_BAIXA:
				return 'Cobertura de núvens baixas (%)';
			case ModeloVarianteVariavelNebulosidade.NEBULOSIDADE_MEDIA:
				return 'Cobertura de núvens médias (%)';
			case ModeloVarianteVariavelNebulosidade.NEBULOSIDADE_ALTA:
				return 'Cobertura de núvens altas (%)';
			case ModeloVarianteVariavelNebulosidade.NEBULOSIDADE_TOTAL:
				return 'Cobertura total de núvens (%)';
			default:
				return '';
		}
	},
	getTimeIndexSteps: (_: ModeloVarianteVariavelNebulosidade | string): number =>
		1,
};

enum ModeloVarianteVariavelAlturaGeopotencial {
	ALTURA_GEOPOTENCIAL_250 = 'ALTURA_GEOPOTENCIAL_250',
	ALTURA_GEOPOTENCIAL_500 = 'ALTURA_GEOPOTENCIAL_500',
	ALTURA_GEOPOTENCIAL_700 = 'ALTURA_GEOPOTENCIAL_700',
}

export const VarianteVariavelAlturaGeopotencial: VarianteVariavel<
	typeof ModeloVarianteVariavelAlturaGeopotencial
> = {
	enum: ModeloVarianteVariavelAlturaGeopotencial,
	getLabel: (
		variante: ModeloVarianteVariavelAlturaGeopotencial | string
	): string => {
		switch (variante) {
			case ModeloVarianteVariavelAlturaGeopotencial.ALTURA_GEOPOTENCIAL_250:
				return 'Altura geopotencial a 250 hPa (m)';
			case ModeloVarianteVariavelAlturaGeopotencial.ALTURA_GEOPOTENCIAL_500:
				return 'Altura geopotencial a 500 hPa (m)';
			case ModeloVarianteVariavelAlturaGeopotencial.ALTURA_GEOPOTENCIAL_700:
				return 'Altura geopotencial a 700 hPa (m)';
			default:
				return '';
		}
	},
	getTimeIndexSteps: (
		_: ModeloVarianteVariavelAlturaGeopotencial | string
	): number => 1,
};

export const getVariante = (
	variavel: ModeloVariavel
): VarianteVariavel<any> | undefined => {
	switch (variavel) {
		case ModeloVariavel.PRECIPITACAO:
			return VarianteVariavelPrecipitacao;
		case ModeloVariavel.TEMPERATURA:
			return VarianteVariavelTemperatura;
		case ModeloVariavel.UMIDADE_AR:
			return VarianteVariavelUmidade;
		case ModeloVariavel.VENTO:
			return VarianteVariavelVento;
		case ModeloVariavel.DIVERGENCIA_VENTO:
			return VarianteVariavelDivergenciaVento;
		case ModeloVariavel.VORTICIDADE_RELATIVA:
			return VarianteVariavelVorticidadeRelativa;
		case ModeloVariavel.NEBULOSIDADE:
			return VarianteVariavelNebulosidade;
		case ModeloVariavel.ALTURA_GEOPOTENCIAL:
			return VarianteVariavelAlturaGeopotencial;
		default:
			return undefined;
	}
};
